/**
 * LE PERMALIEN D'UN FICHIER DE CONCIERGERIE.
 *
 * Une adresse fixe, qui ne change ni avec le temps ni avec la personne qui
 * l'ouvre : `/conciergerie/fichiers/<id>`. Elle ne donne rien par elle-même —
 * la page qu'elle ouvre demande le fichier au serveur avec la session de celui
 * qui clique : l'équipe par le back-office, un formateur par son espace, et
 * seulement tant que son accès au dossier court. Retirer l'accès ou supprimer
 * le fichier coupe donc le lien sans avoir à le révoquer.
 *
 * Source unique : la case qui copie le lien, la route qui le sert, la liste des
 * pages publiques et la redirection après connexion lisent toutes ce fichier.
 */

const MOTIF_CHEMIN = /^\/conciergerie\/fichiers\/\d+$/

export function cheminLienFichierConciergerie(fichierId) {
  return `/conciergerie/fichiers/${fichierId}`
}

export function urlLienFichierConciergerie(fichierId, origine = window.location.origin) {
  return `${origine}${cheminLienFichierConciergerie(fichierId)}`
}

/** Vrai pour le chemin exact d'un permalien — rien de plus, rien d'autre. */
export function estCheminLienFichierConciergerie(chemin) {
  return typeof chemin === 'string' && MOTIF_CHEMIN.test(chemin)
}
